module.exports = __webpack_public_path__ + "img/icon_classify05.ce260572.png";